import React from 'react';
import { Backdrop, CircularProgress } from "@mui/material";
import { ENV_DECLARONS, ENV_VERIFIED_TRAINER, isBrandActive } from '../config/environment.config';
import { animationTeachr } from '../Utils/Images';
import { useTailwindBrand } from './shared';

const BackdropLoad = () => {
    const {classes, brandConfig} = useTailwindBrand()
    return (
        <div className={`h-screen w-full ${classes.bgRootLoader} `}>
            <div className="loader-container mx-auto h-full flex items-center lg:w-1/4 w-1/2">
                <Backdrop
                    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, display: 'flex', flexDirection: 'column', gap: '20px' })}
                    open={true}
                >
                    <CircularProgress color="inherit" />
                    <img src={isBrandActive(ENV_VERIFIED_TRAINER) || isBrandActive(ENV_DECLARONS) ? brandConfig.assets.logoWhite : animationTeachr} alt="Chargement..." className={`loader mx-auto w-1/4`} />
                </Backdrop>
            </div>
        </div>
    );
};

export default BackdropLoad;